module.exports = __webpack_public_path__ + "static/media/shutterstock_90267736.cb7e41ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/shutterstock_90267736.png
// module id = 2246
// module chunks = 0